// 1
import col1 from "../image/col1.webp";
import col1_1 from "../image/col1-1.webp";
import col1_2 from "../image/col1-2.webp";
import col1_3 from "../image/col1-3.webp";
import col1_4 from "../image/col1-4.webp";
import col1_5 from "../image/col1-5.webp";
import col1_6 from "../image/col1-6.webp";
import col1_7 from "../image/col1-7.webp";
import col1_8 from "../image/col1-8.webp";
import col1_9 from "../image/col1-9.webp";

// 2
import col2 from "../image/col2.webp";
import col2_1 from "../image/col2-1.webp";
import col2_2 from "../image/col2-2.webp";
import col2_3 from "../image/col2-3.webp";
import col2_4 from "../image/col2-4.webp";
import col2_5 from "../image/col2-5.webp";
import col2_6 from "../image/col2-6.webp";
import col2_7 from "../image/col2-7.webp";
import col2_8 from "../image/col2-8.webp";

// 3
import col3 from "../image/col3.webp";
import col3_1 from "../image/col3-1.webp";
import col3_2 from "../image/col3-2.webp";
import col3_3 from "../image/col3-3.webp";
import col3_4 from "../image/col3-4.webp";
import col3_5 from "../image/col3-5.webp";
import col3_6 from "../image/col3-6.webp";
import col3_7 from "../image/col3-7.webp";
import col3_8 from "../image/col3-8.webp";
import col3_9 from "../image/col3-9.webp";
import col3_10 from "../image/col3-10.webp";

// 4
import col4 from "../image/col4.webp";
import col4_1 from "../image/col4-1.webp";
import col4_2 from "../image/col4-2.webp";
import col4_3 from "../image/col4-3.webp";
import col4_4 from "../image/col4-4.webp";
import col4_5 from "../image/col4-5.webp";
import col4_6 from "../image/col4-6.webp";
import col4_7 from "../image/col4-7.webp";
import col4_8 from "../image/col4-8.webp";
// 5
import col5 from "../image/col5.webp";
import col5_1 from "../image/col5-1.webp";
import col5_2 from "../image/col5-2.webp";
import col5_3 from "../image/col5-3.webp";
import col5_4 from "../image/col5-4.webp";
import col5_5 from "../image/col5-5.webp";
import col5_6 from "../image/col5-6.webp";
import col5_7 from "../image/col5-7.webp";
import col5_8 from "../image/col5-8.webp";

// 6
import col6 from "../image/col6.webp";
import col6_1 from "../image/col6-1.webp";
import col6_2 from "../image/col6-2.webp";
import col6_3 from "../image/col6-3.webp";
import col6_4 from "../image/col6-4.webp";
import col6_5 from "../image/col6-5.webp";
import col6_6 from "../image/col6-6.webp";
import col6_7 from "../image/col6-7.webp";

// 7
import col7 from "../image/col7.webp";
import col7_1 from "../image/col7-1.webp";
import col7_2 from "../image/col7-2.webp";
import col7_3 from "../image/col7-3.webp";
import col7_4 from "../image/col7-4.webp";
import col7_5 from "../image/col7-5.webp";
import col7_6 from "../image/col7-6.webp";
import col7_7 from "../image/col7-7.webp";
import col7_8 from "../image/col7-8.webp";
// 8
import col8 from "../image/col8.webp";
import col8_1 from "../image/col8-1.webp";
import col8_2 from "../image/col8-2.webp";
import col8_3 from "../image/col8-3.webp";
import col8_4 from "../image/col8-4.webp";
import col8_5 from "../image/col8-5.webp";
import col8_6 from "../image/col8-6.webp";
import col8_7 from "../image/col8-7.webp";

// 9
import col9 from "../image/col9.webp";
import col9_1 from "../image/col9-1.webp";
import col9_2 from "../image/col9-2.webp";
import col9_3 from "../image/col9-3.webp";
import col9_4 from "../image/col9-4.webp";
import col9_5 from "../image/col9-5.webp";
import col9_6 from "../image/col9-6.webp";

// 10
import col10 from "../image/col10.webp";
import col10_1 from "../image/col10-1.webp";
import col10_2 from "../image/col10-2.webp";
import col10_3 from "../image/col10-3.webp";
import col10_4 from "../image/col10-4.webp";
import col10_5 from "../image/col10-5.webp";
import col10_6 from "../image/col10-6.webp";
import col10_7 from "../image/col10-7.webp";

// 11
import col11 from "../image/col11.webp";
import col11_1 from "../image/col11-1.webp";
import col11_2 from "../image/col11-2.webp";
import col11_3 from "../image/col11-3.webp";
import col11_4 from "../image/col11-4.webp";
import col11_5 from "../image/col11-5.webp";
import col11_6 from "../image/col11-6.webp";
import col11_7 from "../image/col11-7.webp";

// 12
import col12 from "../image/col12.webp";
import col12_1 from "../image/col12-1.webp";
import col12_2 from "../image/col12-2.webp";
import col12_3 from "../image/col12-3.webp";
import col12_4 from "../image/col12-4.webp";
import col12_5 from "../image/col12-5.webp";
import col12_6 from "../image/col12-6.webp";
import col12_7 from "../image/col12-7.webp";
import col12_8 from "../image/col12-8.webp";

// 13
import col13 from "../image/col13.webp";
import col13_1 from "../image/col13-1.webp";
import col13_2 from "../image/col13-2.webp";
import col13_3 from "../image/col13-3.webp";
import col13_4 from "../image/col13-4.webp";
import col13_5 from "../image/col13-5.webp";
import col13_6 from "../image/col13-6.webp";

// 14
import col14 from "../image/col14.webp";
import col14_1 from "../image/col14-1.webp";
import col14_2 from "../image/col14-2.webp";
import col14_3 from "../image/col14-3.webp";
import col14_4 from "../image/col14-4.webp";
import col14_5 from "../image/col14-5.webp";
import col14_6 from "../image/col14-6.webp";
import col14_7 from "../image/col14-7.webp";

// 15
import col15 from "../image/col15.webp";
import col15_1 from "../image/col15-1.webp";
import col15_2 from "../image/col15-2.webp";
import col15_3 from "../image/col15-3.webp";
import col15_4 from "../image/col15-4.webp";
import col15_5 from "../image/col15-5.webp";
import col15_6 from "../image/col15-6.webp";
// 16
import col16 from "../image/col16.webp";
import col16_1 from "../image/col16-1.webp";
import col16_2 from "../image/col16-2.webp";
import col16_3 from "../image/col16-3.webp";
import col16_4 from "../image/col16-4.webp";
import col16_5 from "../image/col16-5.webp";
import col16_6 from "../image/col16-6.webp";
// 17
import col17 from "../image/col17.webp";
import col17_1 from "../image/col17-1.webp";
import col17_2 from "../image/col17-2.webp";
import col17_3 from "../image/col17-3.webp";
// 18
import col18 from "../image/col18.webp";
import col18_1 from "../image/col18-1.webp";
import col18_2 from "../image/col18-2.webp";
// 19
import col19 from "../image/col19.webp";
import col19_1 from "../image/col19-1.webp";
import col19_2 from "../image/col19-2.webp";
// 20
import col20 from "../image/col20.webp";
import col20_1 from "../image/col20-1.webp";
import col20_2 from "../image/col20-2.webp";
// 21
import col21 from "../image/col21.webp";
import col21_1 from "../image/col21-1.webp";
// 22
import col22 from "../image/col22.webp";
import col22_1 from "../image/col22-1.webp";
import col22_2 from "../image/col22-2.webp";
// 23
import col23 from "../image/col23.webp";
import col23_1 from "../image/col23-1.webp";
import col23_2 from "../image/col23-2.webp";
// 24
import col24 from "../image/col24.webp";
import col24_1 from "../image/col24-1.webp";
import col24_2 from "../image/col24-2.webp";

export const productList = [
  {
    category: "Best Sellers",
    list: [
      {
        id: 1,
        title: `Atna Belt Bag`,
        quantity: 1,
        image: [col1, col1_1, col1_2, col1_3, col1_4, col1_5],
        price: 165,
        total: 165,
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          "Experience the epitome of versatile elegance with the Atna Belt Bag. Crafted from full grain 5oz leather, this petite powerhouse is both robust and refined, designed to seamlessly accompany you wherever life may lead. Its streamlined silhouette is deceptive, capable of accommodating essentials such as your phone, minimalist wallet, sunglasses, and a selection of personal items.",
          "Specifications",
          '• Dimensions: 9.75" L, 6" H, 2.5" W',
          "• Weight: 11.1oz (including strap)",
          '• Strap Length Min: 25.5"',
          '• Strap Length Max: 45"',
          '• Strap Width: 1"',
          "Natural Grain",
          `Leather's natural scars and markings are symbols of authenticity, underscoring each piece's unique story. These characteristics do not affect the item's integrity. Instead, they enhance the beauty, ensuring that each leather good is one-of-a-kind, distinguished from others by its individual character.`,
        ],
      },
      {
        id: 2,
        title: "Kennedy Crossbody",
        quantity: 1,
        image: [col2, col2_1, col2_2, col2_3, col2_4, col2_5],
        price: 325,
        total: 325,
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `The ultra versatile Kennedy Crossbody bag is going to be your new go-to favorite. The Kennedy comes with a fully adjustable cross body strap as well as a short shoulder strap, giving you the ability to choose how to carry. Made of full grain, Horween leather, this bag features a zippered closure and both interior and exterior pockets. Thoughtfully designed and intentionally crafted, the Kennedy fits all styles with a rustic, yet refined look and feel.`,
          "Specifications",
          "• Dimensions approx. 10 inches (wide) x 11 inches (tall) x 4.5 inches (depth)",
          "• Weight: 2lb",
          "• Includes both short and long straps",
          '• Long Strap Length Min: 37"',
          '• Long Strap Length Max: 49"',
          '• Short Strap Length Min: 22.5"',
          '• Strap Width: 1"',
          "Natural Grain",
          `Leather's natural scars and markings are symbols of authenticity, underscoring each piece's unique story. These characteristics do not affect the item's integrity. Instead, they enhance the beauty, ensuring that each leather good is one-of-a-kind, distinguished from others by its individual character.`,
        ],
      },
      {
        id: 3,
        title: "Denali Market Tote",
        quantity: 1,
        image: [col3, col3_1, col3_2, col3_3, col3_4],
        price: 475,
        total: 475,
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `The Denali Market Tote is your everyday essential for carrying all the necessities with effortless style. Made from full-grain leather, this tote boasts durability while developing a rich patina over time. The interior provides ample space, easily fitting a laptop, notebooks, or a weekend’s worth of essentials. With sturdy handles, it's both functional and fashionable for market runs or daily commutes. Handcrafted to last, this tote marries simplicity with timeless elegance, making it a versatile addition to your collection.`,
          "Specifications",
          "• Full-grain 5oz Leather",
          '• Interior: 17" x 11.5"',
          '• Exterior: 19"(top) 15.5"(bottom) x 12" x 5.25"',
          '• Straps: 10.25" to top of bag',
          "Natural Grain",
          `Leather's natural scars and markings are symbols of authenticity, underscoring each piece's unique story. These characteristics do not affect the item's integrity. Instead, they enhance the beauty, ensuring that each leather good is one-of-a-kind, distinguished from others by its individual character.`,
        ],
      },
      {
        id: 4,
        title: `Augusta Crossbody`,
        quantity: 1,
        image: [col4, col4_1, col4_2, col4_3],
        price: 145,
        total: 145,
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          "This minimal, full grain leather cross body bag is perfect for the essentials. Outfitted with a fully adjustable cross body strap, this bag will easily accommodate a minimalist wallet, phone, sunglasses and a few other small items. Take what you need without the bother of a big bag on your next outing. The strap is also removable to convert the purse into a small clutch.",
          "Specifications",
          "• Dimensions: 7.5 inches (wide) x 6 inches (high) x 1 inch (deep)",
          "• Weight: 9.8oz (including strap)",
          '• Strap Length Min: 21"',
          '• Strap Length Max: 57"',
          '• Strap Width: 3/4"',
          "Natural Grain",
          `Leather's natural scars and markings are symbols of authenticity, underscoring each piece's unique story. These characteristics do not affect the item's integrity. Instead, they enhance the beauty, ensuring that each leather good is one-of-a-kind, distinguished from others by its individual character.`,
        ],
      },
      {
        id: 5,
        title: "Atna Mini Belt Bag",
        quantity: 1,
        image: [col5, col5_1, col5_2, col5_3, col5_4],
        price: 135,
        total: 135,
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `The Atna Mini Belt Bag is the perfect companion for those on the go, offering hands-free convenience with a stylish edge. Made from 5oz full-grain leather, this compact bag features a perfectly-sized interior, great for carrying your phone, wallet, and other essentials. Whether worn as a belt bag or crossbody, it provides versatility for any adventure. With its timeless design and durable craftsmanship, the Atna Mini Belt Bag combines functionality and fashion, making it an essential accessory for everyday use.`,
          "Specifications",
          '• Dimensions: 8.5" x 5.25" x 2"',
          '• Strap Length Min: 25.5"',
          '• Strap Length Max: 45"',
          '• Strap Width: 1"',
          "Natural Grain",
          `Leather's natural scars and markings are symbols of authenticity, underscoring each piece's unique story. These characteristics do not affect the item's integrity. Instead, they enhance the beauty, ensuring that each leather good is one-of-a-kind, distinguished from others by its individual character.`,
        ],
      },
      {
        id: 6,
        title: `Princeton Journal`,
        quantity: 1,
        image: [col6, col6_1, col6_2, col6_3, col6_4],
        price: 135,
        total: 135,
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `Meet the Princeton Journal—our roomier, more capable take on the everyday notebook cover. It’s built for longer entries, fuller pages, and the kind of writing that doesn’t fit in a pocket-sized field note. Full-grain leather gives it structure and character (and it only gets better with use), while the exterior pen loop keeps your go-to pen right where you need it. Add the quick-access card pocket, and it’s ready for meetings, travel, and everything in between—simple, organized, and made to be carried for years.`,
          "Specifications",
          "• measures 5.5 x 9 inches",
          "• fits 5 x 8.25 in. moleskine cahier",
          "• fits 5 x 8.25 moleskine calendar",
          "• exterior pen and card holders",
          "• includes 1 moleskine cahier",
          "• hand-stitched",
        ],
      },
      {
        id: 7,
        title: `Big Horn Weekender Bag`,
        quantity: 1,
        image: [col7, col7_1, col7_2, col7_3, col7_4],
        price: 895,
        total: 895,
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `Crafted from full-grain Horween leather and stitched in our Laramie shop, the Big Horn Weekender carries just enough for a few days off the grid—or a few nights you won’t want to forget. The wide-mouth opening swallows gear whole; making packing easy and finding gear even easier. Thick straps break in like a good handshake, and the base stands its ground from truck bed to tarmac.`,
          "Stamped with its own number, each bag joins a growing lineage of hands, hides, and miles—proof that what we make here keeps going long after it leaves.",
          `This isn’t the kind of bag you baby. It’s the kind that earns its keep, darkening with miles and years until it looks more like you than it did the day you met.`,
          "Natural Grain",
          `Leather's natural scars and markings are symbols of authenticity, underscoring each piece's unique story. These characteristics do not affect the item's integrity. Instead, they enhance the beauty, ensuring that each leather good is one-of-a-kind, distinguished from others by its individual character.`,
        ],
      },
      {
        id: 8,
        title: `Gannett Wallet`,
        quantity: 1,
        image: [col8, col8_1, col8_2, col8_3, col8_4],
        price: 55,
        total: 55,
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `Our Gannett minimalist wallet is a slim wallet designed to carry the daily essentials. Constructed from full-grain Horween leather, this handcrafted wallet features vertical and horizontal openings and a quick-access money slit, making it easy to grab the card you need in seconds.`,
          "Specifications",
          "• 2 card slots",
          "• Holds up to 8 cards",
          "• Holds up to 5 bills",
          "• Hand Saddle Stitched",
          '• Dimensions: 4" x 2.5" x .25" (approx.)',
        ],
      },
      {
        id: 9,
        title: "Crestone Crossbody",
        quantity: 1,
        price: 235,
        total: 235,
        image: [col9, col9_1, col9_2, col9_3, col9_4],
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          "Made of full grain 5oz leather, the Crestone Crossbody is a minimalistic take on our best selling Kennedy Crossbody. Featuring a roomy interior with inner accessories pocket and magnet closure, this will become your go-to bag for every outing—from a picnic in the park to a night on the town.",
          "Specifications",
          '• Approximate Dimensions: 10.5" L, 9" H, 3.25" W',
          "• Weight: 1lb 5oz (including strap)",
          '• Strap Length Min: 37"',
          '• Strap Length Max: 49"',
          '• Strap Width: 3/4"',
          "Natural Grain",
          `Leather's natural scars and markings are symbols of authenticity, underscoring each piece's unique story. These characteristics do not affect the item's integrity. Instead, they enhance the beauty, ensuring that each leather good is one-of-a-kind, distinguished from others by its individual character.`,
        ],
      },
      {
        id: 10,
        title: "Helena Clutch",
        quantity: 1,
        price: 155,
        total: 155,
        image: [col10, col10_1, col10_2, col10_3, col10_4],
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `The Helena Clutch seamlessly blends timeless style with modern functionality, handcrafted from full-grain Horween leather in our Laramie workshop. Featuring a thoughtfully designed interior with hand-stitched pockets for up to 8 cards and a dual-compartment cash pocket, plus a secure snap closure and convenient clutch strap, this versatile accessory transitions effortlessly from day to evening. Unlike mass-produced wallets that quickly wear out, the Helena develops a rich, unique patina over time—becoming more beautiful with each use while maintaining its structure and elegant slim profile. Backed by our lifetime construction guarantee, this clutch isn't just an accessory; it's an investment in quality American craftsmanship that will accompany you through life's moments for years to come.`,
          "Specifications",
          '• Strap Length Min: 13"',
          '• Strap Width: 3/8"',
        ],
      },
      {
        id: 11,
        title: "Mesa Tote",
        quantity: 1,
        price: 335,
        total: 335,
        image: [col11, col11_1, col11_2, col11_3],
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          "The Mesa Tote is the sister bag to our Sierra Tote. With a zipper closure and exterior stitch line, the Mesa Tote pairs style and function. The interior of the tote features a hand stitch pocket along with a D-ring key clip perfectly organizing all your essentials. The Mesa measures 13 inches wide, 12 inches tall and 6 inches deep -- making it an excellent everyday carry bag. ",
          "Specifications",
          "• Includes Elviroxab Leather Cream for conditioning & waterproofing",
          "• Crafted with full grain, vegetable tanned Horween leather",
          "• Forever Guarantee",
          '• Dimensions: 13" wide, 12" tall, 6" deep',
          '• Strap Hang: 11" from top of tote to bottom of strap',
          "• Weight: 2lb 2.6oz",
          "• Includes Elviroxab Leather cream for conditioning and waterproofing.",
          "• Zipper Closure",
          "Natural Grain",
          `Leather's natural scars and markings are symbols of authenticity, underscoring each piece's unique story. These characteristics do not affect the item's integrity. Instead, they enhance the beauty, ensuring that each leather good is one-of-a-kind, distinguished from others by its individual character.`,
        ],
      },
      {
        id: 12,
        title: "Rainier Mini Crossbody Tote",
        quantity: 1,
        price: 245,
        total: 245,
        image: [col12, col12_1, col12_2, col12_3, col12_4],
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          "The Rainier Mini Crossbody Tote is an elevated everyday bag with clean lines and a structured feel. Crafted from full-grain Horween leather in our Laramie, Wyoming workshop, it’s made to hold its shape, develop a rich patina, and stay in rotation for years.",
          "Carry it by the handles for a polished look, or clip on the removable strap for hands-free days. The interior fits the essentials like phone, wallet, keys, and a few extras, with exterior pockets to keep your go-to items within reach.",
          "Specifications",
          "• 5oz Full-grain Leather",
          '• Interior: 9" x 8.5"',
          '• Exterior: 9.75" x 8.5" x 4.75"',
          '• Straps: 3" from top of bag',
          '• Strap Length Min: 42.5"',
          '• Strap Length Max: 55.5"',
          '• Strap Width: 3/4"',
          "Natural Grain",
          `Leather's natural scars and markings are symbols of authenticity, underscoring each piece's unique story. These characteristics do not affect the item's integrity. Instead, they enhance the beauty, ensuring that each leather good is one-of-a-kind, distinguished from others by its individual character.`,
        ],
      },
      {
        id: 17,
        title: "Washburn Wallet",
        quantity: 1,
        price: 65,
        total: 65,
        image: [col17, col17_1, col17_2, col17_3],
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `The Washburn Wallet redefines everyday carry with its revolutionary wrap design—a first in the leather wallet space meticulously crafted by our innovative product team. Handcrafted from full-grain 5oz Horween leather that develops a rich, personal patina over time, this minimalist wallet comfortably houses 8 cards and 5 bills without the bulk that slows you down. Each hand-stitched seam ensures exceptional durability while maintaining a slim profile that slips effortlessly into front pockets or dress pants. Whether you're sealing business deals downtown or embarking on weekend adventures, the Washburn stands ready as a testament to your discerning taste—because the man who values quality knows that what he carries matters just as much as how he carries himself. Guaranteed for life, just like every Range Leather product that's crafted to wear in, not out.`,
        ],
      },
      {
        id: 18,
        title: "Morgan Planter",
        quantity: 1,
        price: 25,
        total: 25,
        image: [col18, col18_1, col18_2],
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `Our leather wrapped Morgan Planters are the perfect addition to any home's decor. Combining clean lines and a natural look we love how these planters show off your plant of choice and bring a little bit of the outside, in.`,
          "*plant not included",
          "Specifications",
          "• 4 inch diameter",
          "• 3.5 inches tall",
          "• Glass insert with Horween leather wrap",
          "• plant not included",
        ],
      },
      {
        id: 19,
        title: "Valet Tray",
        quantity: 1,
        price: 45,
        total: 45,
        image: [col19, col19_1, col19_2],
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Umber", "Coffee", "Black"],
          },
        ],
        checked: "Umber",
        descript: [
          "Description",
          "Upgrade your home organization with our elegant leather Valet Tray. Expertly crafted from 8oz full-grain leather, this tray gains character and richness with age, showcasing a graceful patina. Its clean, minimalist design and sharp-edge detailing make it a perfect catch-all for keys, jewelry, and other small essentials, adding a touch of sophistication to any space.",
          "Specifications",
          '• Dimensions: 7 2/4"L x 5 1/4"H x 1"D',
          "• Full-grain 8oz leather",
          "• Patina develops over time",
          "• Leather is a natural product that may have imperfections",
        ],
      },
      {
        id: 20,
        title: "Buffalo Coasters",
        quantity: 1,
        price: 35,
        total: 35,
        image: [col20, col20_1, col20_2],
        ishover: false,
        descript: [
          "Description",
          "Embrace the rugged charm of the American West with our Buffalo Leather Coasters. Elevate your home or office decor with impressive heat-stamped detail and full-grain durability.",
          "Contains: Set of 4 coasters",
        ],
      },
      {
        id: 21,
        title: "Steamboat Coasters",
        quantity: 1,
        price: 35,
        total: 35,
        image: [col21, col21_1],
        ishover: false,
        descript: [
          "Description",
          "Celebrate your Cowboy pride with our University of Wyoming Steamboat Leather Coaster. Meticulously crafted from full-grain 8oz Horween Chromexcel leather, this coaster features a dimensional heat-stamped Steamboat logo that preserves the integrity of the leather while offering superior liquid resistance. As beautiful as it is functional, this heirloom-quality piece develops a rich patina over time, telling the story of your Wyoming spirit with every use.",
          "Contains: Set of 4 coasters",
        ],
      },
      {
        id: 22,
        title: "Vintage Sunrise Coasters",
        quantity: 1,
        price: 35,
        total: 35,
        image: [col22, col22_1, col22_2],
        ishover: false,
        descript: [
          "Description",
          `Capture the essence of mountain living with our Vintage Sunrise Leather Coaster. Meticulously crafted from full-grain 8oz Horween Chromexcel leather, this coaster showcases a hand-drawn mountain sunrise design, heat-stamped for exceptional depth and character while maintaining the leather's natural integrity. As beautiful as it is functional, this heirloom-quality piece offers superior liquid resistance while developing a rich patina over time, bringing the spirit of outdoor adventure to your everyday moments.`,
          "Contains: Set of 4 coasters",
        ],
      },
      {
        id: 23,
        title: "Range Mountain Coasters",
        quantity: 1,
        price: 35,
        total: 35,
        image: [col23, col23_1, col23_2],
        ishover: false,
        descript: [
          "Description",
          `Embrace the rugged charm of the American West with our Range Mountain Leather Coasters. Elevate your home or office decor with impressive heat-stamped detail and full-grain durability.`,
          "Contains: Set of 4 coasters",
        ],
      },
      {
        id: 24,
        title: "Americana Trout Coasters",
        quantity: 1,
        price: 35,
        total: 35,
        image: [col24, col24_1, col24_2],
        ishover: false,
        descript: [
          "Description",
          `Celebrate the timeless tradition of western fly fishing with our Americana Trout Leather Coaster. Meticulously crafted from full-grain 8oz Horween Chromexcel leather, this coaster features a dynamic trout design heat-stamped for exceptional depth and character while maintaining the leather's natural integrity. As beautiful as it is functional, this heirloom-quality piece offers superior liquid resistance while developing a rich patina over time, bringing the spirit of the western frontier's favorite pastime to your everyday moments.`,
          "Contains: Set of 4 coasters",
        ],
      },
    ],
  },

  {
    category: "You may also like",
    list: [
      {
        id: 13,
        title: "Elbert Wallet",
        quantity: 1,
        price: 105,
        total: 105,
        image: [col13, col13_1, col13_2, col13_3, col13_4],
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `This standard men's bifold wallet has four accessible pockets, allowing you to store upwards of ten cards. The traditional design and classic layout of the Elbert is perfect for anyone looking for a premium, hand crafted wallet.`,
          "Specifications",
          "• 4 card slots",
          "• Holds up to 12 cards",
          "• Holds up to 15 bills",
          "• Hand Saddle Stitched",
          "• Dimensions: approx. 4.5 x 3.25 x .5 inches",
        ],
      },
      {
        id: 14,
        title: "McKinley Clutch",
        quantity: 1,
        price: 115,
        total: 115,
        image: [col14, col14_1, col14_2, col14_3, col14_4],
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `The epitome of chic, the McKinley Clutch is designed for functionality and style. The small clutch fits all of your essentials and includes a wristlet zipper pull for hands free carry, all while fitting inside the Sierra Tote and Kennedy Crossbody Purse.`,
          "Specifications",
          '• Dimensions: 8.25" L, 5" H, 1.25" W',
          "• Weight: 4.6oz (including strap)",
          '• Strap Length Min: 13"',
          '• Strap Width: 3/8"',
          "Natural Grain",
          `Leather's natural scars and markings are symbols of authenticity, underscoring each piece's unique story. These characteristics do not affect the item's integrity. Instead, they enhance the beauty, ensuring that each leather good is one-of-a-kind, distinguished from others by its individual character.`,
        ],
      },
      {
        id: 15,
        title: "Jarvis Card Holder",
        quantity: 1,
        price: 45,
        total: 45,
        image: [col15, col15_1, col15_2, col15_3, col15_4],

        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          `Elevate your everyday carry with our Jarvis Card Holder, a sleek sanctuary for your most essential cards crafted from premium Horween full-grain 5oz leather that develops a rich, unique patina with every use. Designed specifically to slip effortlessly into your favorite handbag or tote, this meticulously hand-stitched holder securely stores up to 10+ credit cards or 20+ business cards with a convenient snap closure that keeps everything protected yet instantly accessible. More than just a practical storage solution, the Jarvis represents thoughtful organization wrapped in timeless style – finally freeing you from digging through your bag for that elusive loyalty card or business contact while delivering the lifetime durability that's the signature of everything we craft in our Laramie, Wyoming workshop.`,
        ],
      },
      {
        id: 16,
        title: "Bennett Journal",
        quantity: 1,
        price: 60,
        total: 60,
        image: [col16, col16_1, col16_2, col16_3, col16_4],
        ishover: false,
        sku: [
          {
            title: "Color",
            list: ["Natural", "Nut Brown", "Maple", "Black"],
          },
        ],
        checked: "Natural",
        descript: [
          "Description",
          "Introducing the Bennett Journal, a testament to timeless elegance and practical design. Crafted from 5oz full-grain leather, the Bennett Journal exudes a classic, sophisticated feel with a durable build that ages beautifully over time. The full-grain leather ensures each journal has a unique character that becomes more personalized with use.",
          `Keeping your ideas secure and organized is effortless with the Bennett's elastic notebook attachment system. This feature allows for easy replacement of your notebook, ensuring that your journal adapts to your evolving writing journey. The iconic Topo Design snap adds a distinctive touch while providing a secure closure, making the Bennett Journal an ideal companion for both everyday use and travel. Whether you're jotting down reflections, sketching, or planning your next adventure, the Bennett Journal is an excellent choice for anyone who values quality and style in their writing essentials.`,
          "Specifications",
          '• 5 1/2"w x 8 5/8" h',
          "• One Moleskine Cahier Notebook Included",
          "• Fits 5.5”x8.25” Notebooks, Large Moleskine",
          "• 5oz Full-Grain Leather",
          "• Elastic Notebook Attachment",
          "• Iconic Topo Design Snap",
        ],
      },
    ],
  },
];

export const getProductDetailById = (id) => {
  let product;
  for (const item of productList) {
    product = item.list.find((itemProduct) => itemProduct.id === id);
    if (product) return product;
  }
  return undefined;
};

// find
export const getCategoryList = (type) => {
  let list = productList.find((item) => item.category === type);
  return list;
};
